export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/active-agenda/components/consultations-made/resources/data.js